import { useEffect, useState } from "react";
import { scrollToId } from "@/lib/scroll";

export const StickyCta = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const requestEl = document.getElementById("request");
    let onForm = false;
    const observer = requestEl
      ? new IntersectionObserver(([entry]) => {
          onForm = entry.isIntersecting;
          setVisible(window.scrollY > window.innerHeight * 0.7 && !onForm);
        })
      : null;
    requestEl && observer?.observe(requestEl);
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.7 && !onForm);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      observer?.disconnect();
    };
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`fixed bottom-0 inset-x-0 z-50 md:hidden transition-transform duration-500 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="bg-[#0A0A0B]/95 backdrop-blur-md border-t border-graphite px-5 py-3.5">
        <button
          data-testid="sticky-cta-request-service"
          onClick={() => scrollToId("request")}
          className="w-full font-accent text-xs tracking-[0.25em] uppercase bg-volt text-white py-4 hover:bg-[#4A8FFF] transition-colors duration-300"
        >
          Request Service
        </button>
      </div>
    </div>
  );
};
